// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/v1/receiver.proto (package mochabugapis.adapt.graph.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { SignalBinding, SignalBindingJson } from "./signal_binding_pb";
import { file_mochabugapis_adapt_graph_v1_signal_binding } from "./signal_binding_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/v1/receiver.proto.
 */
export const file_mochabugapis_adapt_graph_v1_receiver: GenFile = /*@__PURE__*/
  fileDesc("Ciptb2NoYWJ1Z2FwaXMvYWRhcHQvZ3JhcGgvdjEvcmVjZWl2ZXIucHJvdG8SG21vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MSLQAgoIUmVjZWl2ZXISMwoEbmFtZRgBIAEoCUIlukgiciAQARgyMhpeW18kYS16QS1aXVtfJGEtekEtWjAtOV0qJBIcCgVsYWJlbBgCIAEoCUIIukgFcgMY+gFIAIgBARIiCgtkZXNjcmlwdGlvbhgDIAEoCUIIukgFcgMY+gFIAYgBARKyAQoIYmluZGluZ3MYBCADKAsyKi5tb2NoYWJ1Z2FwaXMuYWRhcHQuZ3JhcGgudjEuU2lnbmFsQmluZGluZ0J0ukhxugFoChViaW5kaW5nc191bmlxdWVfbmFtZXMSJUVhY2ggYmluZGluZyBtdXN0IGhhdmUgYSB1bmlxdWUgbmFtZS4aKHRoaXMubWFwKGJpbmRpbmcsIGJpbmRpbmcubmFtZSkudW5pcXVlKCmSAQMQgARCCAoGX2xhYmVsQg4KDF9kZXNjcmlwdGlvbmIGcHJvdG8z", [file_buf_validate_validate, file_mochabugapis_adapt_graph_v1_signal_binding]);

/**
 * Receiver represents an input point for a vertex, which can bind
 * to multiple signals.
 *
 * @generated from message mochabugapis.adapt.graph.v1.Receiver
 */
export type Receiver = Message<"mochabugapis.adapt.graph.v1.Receiver"> & {
  /**
   * Identifier for the receiver, conforming to the ECMA naming pattern
   * and limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional human-readable label for the receiver, up to 250 characters.
   *
   * @generated from field: optional string label = 2;
   */
  label?: string | undefined;

  /**
   * Optional descriptive text for the receiver's purpose, up to 250 characters.
   *
   * @generated from field: optional string description = 3;
   */
  description?: string | undefined;

  /**
   * List of signals the receiver listens for. Can contain up to 512 unique signals.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.SignalBinding bindings = 4;
   */
  bindings: SignalBinding[];
};

/**
 * Receiver represents an input point for a vertex, which can bind
 * to multiple signals.
 *
 * @generated from message mochabugapis.adapt.graph.v1.Receiver
 */
export type ReceiverJson = {
  /**
   * Identifier for the receiver, conforming to the ECMA naming pattern
   * and limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * Optional human-readable label for the receiver, up to 250 characters.
   *
   * @generated from field: optional string label = 2;
   */
  label?: string;

  /**
   * Optional descriptive text for the receiver's purpose, up to 250 characters.
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * List of signals the receiver listens for. Can contain up to 512 unique signals.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.SignalBinding bindings = 4;
   */
  bindings?: SignalBindingJson[];
};

/**
 * Describes the message mochabugapis.adapt.graph.v1.Receiver.
 * Use `create(ReceiverSchema)` to create a new message.
 */
export const ReceiverSchema: GenMessage<Receiver, {jsonType: ReceiverJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_v1_receiver, 0);

